<template>
  <div class="productFourth">
    <div class="rateBox">
      <ul class="pcul">
        <li>
          <span class="title">美元今日汇率</span>
          <div class="usa">
            <div class="flexs">
              <img class="firstImg" src="@/assets/imgs/product/currency_3.png" alt="">
              <div class="deract">
                <span>美元</span>
                <span>USD</span>
              </div>
            </div>
            <span class="num">1</span>
          </div>

          <span class="icon"> = </span>
          <div>
            <div class="usa">
              <div class="flexs">
                <img class="firstImg" src="@/assets/imgs/product/currency_1.png" alt="">
                <div class="deract">
                  <span>人民币</span>
                  <span>CNY</span>
                </div>
              </div>
              <span class="num">{{ todayData.dollerRmbRate }}</span>
            </div>
            <span style="margin: 0 18px;"> / </span>

            <div class="usa">
              <div class="flexs">
                <img class="firstImg" src="@/assets/imgs/product/currency_2.png" alt="">
                <div class="deract">
                  <span>港币</span>
                  <span>HKD</span>
                </div>
              </div>
              <span class="num">{{ todayData.dollerHongkongRate }}</span>
            </div>



          </div>
        </li>
        <li style="margin-top: 80px;">
          <span class="title">港币今日汇率</span>
          <div class="usa">
            <div class="flexs">
              <img class="firstImg" src="@/assets/imgs/product/currency_2.png" alt="">
              <div class="deract">
                <span>港币</span>
                <span>HKD</span>
              </div>
            </div>
            <span class="num">1</span>
          </div>
          <span class="icon"> = </span>
          <div class="usa">
            <div class="flexs">
              <img class="firstImg" src="@/assets/imgs/product/currency_1.png" alt="">
              <div class="deract">
                <span>人民币</span>
                <span>CNY</span>
              </div>
            </div>
            <span class="num">{{ todayData.hongkongRmbRate }}</span>
          </div>
        </li>
      </ul>
      <ul class="wapul">
        <li>
          <span>美元今日汇率</span>
          <div class="usa">
            <div class="flexs">
              <img class="firstImg" src="@/assets/imgs/product/currency_3.png" alt="">
              <div class="deract">
                <span>美元</span>
                <span>USD</span>
              </div>
            </div>
            <span class="num">1</span>
          </div>

          <span class="common"> = </span>
          <div class="usa">
            <div class="flexs">
              <img class="firstImg" src="@/assets/imgs/product/currency_3.png" alt="">
              <div class="deract">
                <span>人民币</span>
                <span>CNY</span>
              </div>
            </div>
            <span class="num">{{ todayData.dollerRmbRate }}</span>
          </div>
          <div class="divP usa" style="margin-top: 20px;">
            <div class="flexs">
              <img class="firstImg" src="@/assets/imgs/product/currency_3.png" alt="">
              <div class="deract">
                <span>港币</span>
                <span>HKD</span>
              </div>
            </div>
            <span class="num">{{ todayData.dollerHongkongRate }}</span>
          </div>
          <!-- <div>
            <p class="usa">
              <img src="@/assets/imgs/product/currency_2.png" alt="">
              <span>港币</span>
              <span>{{todayData[1].MJ_GBRate}}</span>

            </p>
            <p class="divP usa">
              <img src="@/assets/imgs/product/currency_1.png" alt="">
              <span>人民币</span>

              <span>{{todayData[1].MJ_RMBRate}}</span>
            </p>
          </div> -->
        </li>
        <li>
          <span>港币今日汇率</span>
          <div class="usa">
            <div class="flexs">
              <img class="firstImg" src="@/assets/imgs/product/currency_2.png" alt="">
              <div class="deract">
                <span>港币</span>
                <span>HKD</span>
              </div>
            </div>
            <span class="num">1</span>
          </div>
          <span class="common"> = </span>

          <div class="usa">
            <div class="flexs">
              <img class="firstImg" src="@/assets/imgs/product/currency_1.png" alt="">
              <div class="deract">
                <span>人民币</span>
                <span>CNY</span>
              </div>
            </div>
            <span class="num">{{ todayData.hongkongRmbRate }}</span>


          </div>
          <p></p>

        </li>
      </ul>
    </div>

    <p class="centerP">本平台的结算货币均为美元，为节省客户交易成本，平台将依照市场汇率而更新取款汇率。</p>
    <div class="detailTable">
      <el-table :data="tableData" stripe border style="width: 100%;margin: 0 auto;"
        :header-cell-style="{ textAlign: 'center', background: 'rgb(250, 35, 20)', color: '#393a39', color: '#fff', border: 'none', fontSize: '18px' }"
        :header-row-style="{ height: '75px' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="date" label="" min-width="30%">
        </el-table-column>
        <el-table-column prop="dollerHongkongRate" label="美元/港币" min-width="40%">
          <template slot-scope="scope">
            <span>1:{{ scope.row.dollerHongkongRate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dollerRmbRate" label="美元/人民币" min-width="40%">
          <template slot-scope="scope">
            <span>1:{{ scope.row.dollerRmbRate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="hongkongRmbRate" label="港币/人民币" min-width="40%">
          <template slot-scope="scope">
            <span>1:{{ scope.row.hongkongRmbRate }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ul class="productBottom">
      <li>有关汇率细则如下：</li>
      <li>1.若客户以人民币进行取款时，需参考本公司公布的市场汇率作兑换;</li>
      <li>2.若客户注资时存入人民币，则根据第三方支付平台提供的汇率作兑换;</li>
      <li>3.若客户以港币作为资金存取时，需参考本公司公布的市场汇率作为兑换。</li>
      <li>本公司提供的汇率价格公开透明，绝不任意收取费用。</li>
    </ul>
  </div>
</template>

<script>
import { stringify } from 'querystring';
import { TodayList, sevenDayList, getTodayData,outGoldRateLogs } from '@/apis/common'
export default {
  name: 'productFourth',
  
  data() {
    return {
      // 近七日历史汇率
      tableData: [],
      // 今日汇率
      todayData: {},
    }
  },
  created() {
    this.initTodayList(stringify({ type: 2, isForSite: 1, }));
    this.initSevenDayList(stringify({ type: 2, days: 7 }));
  },
  methods: {
    initTodayList(attr) {
      getTodayData({type:2}).then(res=>{
        this.todayData=res
      })
      // TodayList(attr).then(res => {
      //   if (res.IsSuccess == true) {
      //     this.todayData = res.Message;
      //   }
      // }).catch(err => {
      //   console.log(err);
      // })
    },
    initSevenDayList(attr) {
      outGoldRateLogs().then(res => {
               this.tableData = res;
 
      })
    }
  }
}
</script>

<style lang="less" scoped>
.productFourth {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 100px;

  .rateBox {
    width: 1220px;
    height: 251px;
    margin: 0 auto;
    // border: 2px solid #e8edf1;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    .pcul {
      display: block;

      .usa {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 238px;
        height: 44px;
        border: 1px solid #C9C9CF
      }

      .common {
        font-size: 20px;
      }

      .icon {

        margin: 0 18px;
      }
       .title{
        margin-right: 25px;
       }
      .flexs {
        width: 96px;
        display: flex;
        align-items: center;

        background: rgba(239, 239, 239, 0.3);
        margin: 0;
        height: 46px;
        padding-right: 22px;

        img {
          width: 28px;
          height: 22px;
        }

        .divP {
          margin-top: 20px;
        }

        .deract {
          display: flex;
          flex-direction: column;
          align-items: center;

        }

        .deract span:nth-child(1) {
          font-size: 12px;
          line-height: 16px;
          margin: 0;
        }

        .deract span:nth-child(2) {
          color: #93939F;
          font-size: 10px;
          line-height: 14px;
        }
      }
    }

    .wapul {
      display: none;
    }

    ul {
      width: 100%;
      height: 70%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      li {
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #333333;
        font-weight: 600;
        white-space: nowrap;

        .firstImg {
          margin: 0 13px 0 25px;
        }

        .num {
          width: 120px;
          height: 40px;
          // border: 1px solid #dcdcdc;
          text-align: center;
          line-height: 42px;
        }

        span:nth-child(4) {
          margin: 0 50px 0 13px;
        }

        div {
          // margin-left: 12px;
          display: flex;
          align-items: center;

          p {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            span:nth-child(2) {
              display: inline-block;
              width: 120px;
              height: 40px;
              border: 1px solid #dcdcdc;
              text-align: center;
              line-height: 42px;
              margin: 0 15px;
            }

            span:nth-child(3) {
              border: none;
            }
          }

          .divP {
            margin-top: 20px;
          }
        }
      }
    }
  }

  .centerP {
    width: 100%;
    text-align: center;
    color: #666666;
    margin-top: 15px;
  }

  .detailTable {
    width: 1222px;
    box-sizing: border-box;
    padding: 15px 0px 105px;
    margin: 100px auto 0;

    /deep/ .el-table__row {
      height: 80px;
    }

    /deep/ .el-table__row--striped {
      height: 75px;
    }

    /deep/ .el-table__row td:nth-child(1) {
      font-weight: 600 !important;
    }

    /deep/ .el-table .cell {
      white-space: pre-line;
    }

    ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
      background: #f6f8fa;
    }
  }

  .productBottom {
    width: 1222px;
    margin: 0 auto;

    li {
      color: #949494;
      line-height: 30px;
    }

    li:nth-child(1) {
      color: #333333;
      font-weight: 600;
      font-size: 22px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (max-width: 500px) {
  .productFourth {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 50px;

    .rateBox {
      width: 98%;
      height: 490px;
      margin: 0 auto;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 0 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .pcul {
        display: none;

      }

      .wapul {
        display: block;

        li {
          .flexs {
            width: 96px;
            display: flex;
            align-items: center;

            background: rgba(239, 239, 239, 0.3);
            margin: 0;
            height: 46px;
            padding-right: 22px;

            img {
              width: 28px;
              height: 22px;
            }

            .divP {
              margin-top: 20px;
            }

            .deract {
              display: flex;
              flex-direction: column;
              align-items: center;

            }

            .deract span:nth-child(1) {
              font-size: 12px;
              line-height: 16px;
              margin: 0;
            }

            .deract span:nth-child(2) {
              color: #93939F;
              font-size: 10px;
              line-height: 14px;
            }
          }

          div {


            p {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              span:nth-child(2) {
                display: inline-block;
                width: 120px;
                height: 40px;
                border: none;
                text-align: center;
                line-height: 42px;
                margin: 0 15px;
              }

              span:nth-child(3) {
                border: none;
              }
            }

            .divP {
              margin-top: 20px;
            }
          }
        }
      }

      ul {
        width: 100%;
        height: 70%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        li {
          width: 100%;
          display: flex;
          flex-direction: column;

          .usa {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 278px;
            height: 44px;
            border: 1px solid #C9C9CF
          }

          .common {
            font-size: 20px;
          }

          img {
            width: 28px;
          }

          .firstImg {
            margin: 0 5px 0 5px
          }

          span {
            font-size: 12px;
            margin: 0 5px;
          }

          span:nth-child(1) {
            font-size: 18px;
            margin: 36px 0 22px 0;
          }

          span:nth-child(4) {
            margin: 0 5px 0 5px
          }

          .num {
            width: 80px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            border: none;
          }

          div {
            margin-left: 10px;

            p {
              span:nth-child(2) {
                width: 80px;
                height: 28px;
                line-height: 28px;
                font-size: 12px;
              }
            }
          }
        }
      }


    }

    .centerP {
      width: 95%;
      margin: 10px auto 0;
      font-size: 12px;
    }

    /deep/.detailTable {
      width: 100%;
      margin: 30px auto 0;
      padding: 0px 1rem 30px;
      /deep/ .el-table__row td:nth-child(1) {
          font-weight: 500 !important;
        }
             /deep/ .el-table__row td:nth-child(2),.el-table__row td:nth-child(3) {
               font-weight: 600 !important;
             }
      .el-table .cell {
        font-size: 10px !important;
        padding: 0 !important;
      }

      .el-table th,
      .el-table tr {
        height: 50px !important;
      }

      .el-table td,
      .el-table th {
        padding: 5px 0;
      }
    }

    .productBottom {
      width: 100%;
      box-sizing: border-box;
      padding: 0 1rem;

      li:nth-child(1) {
        font-size: 16px;
      }

      li {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
  // -------------------------小屏幕适配-------------------
  @media screen and (min-width: 1264px) and (max-width: 1724px) {
    .productFourth {
        width: 100%;
        box-sizing: border-box;
        padding-bottom: 100px;
    
        .rateBox {
          width: 1000px;
          height: 251px;
          margin: 0 auto;
          // border: 2px solid #e8edf1;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
    
          .pcul {
            display: block;
    
            .usa {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 238px;
              height: 44px;
              border: 1px solid #C9C9CF
            }
    
            .common {
              font-size: 20px;
            }
    
            .icon {
    
              margin: 0 18px;
            }
    
            .title {
              margin-right: 25px;
            }
    
            .flexs {
              width: 96px;
              display: flex;
              align-items: center;
    
              background: rgba(239, 239, 239, 0.3);
              margin: 0;
              height: 46px;
              padding-right: 22px;
    
              img {
                width: 28px;
                height: 22px;
              }
    
              .divP {
                margin-top: 20px;
              }
    
              .deract {
                display: flex;
                flex-direction: column;
                align-items: center;
    
              }
    
              .deract span:nth-child(1) {
                font-size: 12px;
                line-height: 16px;
                margin: 0;
              }
    
              .deract span:nth-child(2) {
                color: #93939F;
                font-size: 10px;
                line-height: 14px;
              }
            }
          }
    
          .wapul {
            display: none;
          }
    
          ul {
            width: 100%;
            height: 70%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
    
            li {
              width: 90%;
              margin: 0 auto;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              color: #333333;
              font-weight: 600;
              white-space: nowrap;
    
              .firstImg {
                margin: 0 13px 0 25px;
              }
    
              .num {
                width: 120px;
                height: 40px;
                // border: 1px solid #dcdcdc;
                text-align: center;
                line-height: 42px;
              }
    
              span:nth-child(4) {
                margin: 0 50px 0 13px;
              }
    
              div {
                // margin-left: 12px;
                display: flex;
                align-items: center;
    
                p {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
    
                  span:nth-child(2) {
                    display: inline-block;
                    width: 120px;
                    height: 40px;
                    border: 1px solid #dcdcdc;
                    text-align: center;
                    line-height: 42px;
                    margin: 0 15px;
                  }
    
                  span:nth-child(3) {
                    border: none;
                  }
                }
    
                .divP {
                  margin-top: 20px;
                }
              }
            }
          }
        }
    
        .centerP {
          width: 100%;
          text-align: center;
          color: #666666;
          margin-top: 15px;
        }
    
        .detailTable {
          width: 1000px;
          box-sizing: border-box;
          padding: 15px 0px 105px;
          margin: 100px auto 0;
    
          /deep/ .el-table__row {
            height: 80px;
          }
    
          /deep/ .el-table__row--striped {
            height: 75px;
          }
    
          /deep/ .el-table__row td:nth-child(1) {
            font-weight: 600 !important;
          }
    
          /deep/ .el-table .cell {
            white-space: pre-line;
          }
    
          ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
            background: #f6f8fa;
          }
        }
    
        .productBottom {
          width: 1000px;
          margin: 0 auto;
    
          li {
            color: #949494;
            line-height: 30px;
          }
    
          li:nth-child(1) {
            color: #333333;
            font-weight: 600;
            font-size: 22px;
            margin-bottom: 20px;
          }
        }
      }
  }
</style>